import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import { useLocation } from 'react-router-dom';

const LoginAuth0Button = () => {
	const { loginWithRedirect } = useAuth0();
	const location = useLocation();

	const handleLogin = () => {
		const from = (location.state as any)?.from;
		const returnTo = from
			? from.pathname + (from.search || '') + (from.hash || '')
			: '/admin/users';

		loginWithRedirect({
			appState: { returnTo },
		});
	};

	return (
		<Button
			variant="outlined"
			color="info"
			type="submit"
			size="large"
			onClick={handleLogin}
			sx={{ width: 140 }}
		>
			Log in
		</Button>
	);
};

export default LoginAuth0Button;
